import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import { User, Table } from 'services/action';
import { Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  isLoading: true,
  name: '',
  phone: '',
  username: '',
  password: '',
  confirm_password: '',
};

export const FormInput = ({ data, onClose }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const StateTable = useSelector((state) => state?.Table?.data['user']);
  const StateWarehouse = useSelector((state) => state?.Auth?.warehouse);

  const dummy = Array.from({ length: 7 }, (v, i) => i);

  const [
    {
      name,
      phone,
      username,
      password,
      confirm_password,
      isLoading,
    },
    setState,
  ] = React.useState(initialState);


  const $handleSubmit = async (c) => {
    const payload = {
      name,
      phone,
      username,
      password,
      confirm_password,
      warehouse_id: StateWarehouse?.id,
      type: 'warehouse',
    };

    if (data) {
      const submit = await Dispatch(User.$update(data?.id, payload));
      if (submit?.message === 'success') {
        onClose();
        Dispatch(Table.$reload('user', StateTable));
      }
    } else {
      const submit = await Dispatch(User.$create(payload));
      if (submit?.message === 'success') {
        onClose();
        Dispatch(Table.$reload('user', StateTable));
      }
    }
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);


  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      name: data?.name,
      phone: data?.phone,
      username: data?.username,
      password: data?.password,
      confirm_password: data?.confirm_password,
    }));
  }, [data]);

  if (isLoading) {
    return (
      <div>
        <div className="row m-0">
          {dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="row ">
        <div className="col-12 col-md-6">
          <Form.Input
            value={name || ''}
            required
            type="text"
            label="Nama"
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                name: e?.target?.value,
              }))
            }
            error={StateForm?.errors?.name}
          />
          <Form.Input
            value={phone || ''}
            type="phone"
            label="Nomor Handphone"
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                phone: e?.target?.value,
              }))
            }
            error={StateForm?.errors?.phone}
          />
        </div>

        <div className="col-12 col-md-6">
          <div className="form-group mb-3 ">
            <Form.Input
              value={username || ''}
              required
              disabled={data ? true : false}
              type="text"
              label="Username"
              autoComplete="new-password"
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  username: e?.target?.value,
                }))
              }
              error={StateForm?.errors?.username}
            />
            <Form.InputAddon
              value={password || ''}
              required
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  password: e?.target?.value,
                }))
              }
              label="Password"
              type="password"
              autoComplete="new-password"
              placeholder=""
              error={StateForm?.errors?.password}
            />
            <Form.InputAddon
              value={confirm_password || ''}
              required
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  confirm_password: e?.target?.value,
                }))
              }
              label="Konfirmasi Password"
              type="password"
              autoComplete="new-password"
              placeholder=""
              error={StateForm?.errors?.confirm_password}
            />
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <Button
          type="button"
          className={cn(
            StateForm?.loading ? 'btn-loading' : '',
            'mt-3 btn btn-primary py-md-2'
          )}
          disabled={StateForm?.loading}
          onClick={$handleSubmit}
        >
          Simpan
        </Button>
      </div>
    </div>
  );
};
